<template>
  <div>
    <el-dialog
      :id="$options.name"
      :before-close="noDialog"
      :fullscreen="dialogFullscreen"
      :visible.sync="dialog"
      title="同步配置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="Dto" :model="configForm" :rules="rules" label-width="auto">
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="同步间隔时间" prop="syncTime">
              <el-input-number
                v-model="configForm.syncTime"
                :min="5"
                :max="30"
              ></el-input-number>
              <span style="margin-left: 10px">秒</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="noDialog">取消</el-button>
        <el-button type="primary" @click="addPost">立即同步</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import { Message } from "element-ui";
import agentGetGroupDetailById from "@/api/device/device-group-manage/agentGetGroupDetailById";
import agentEditSyncConfigGroup from "@/api/device/device-group-manage/agentEditSyncConfigGroup";
import agentSyncConfigGroup from "@/api/device/device-group-manage/agentSyncConfigGroup";

import resDispose from "@/mixin/resDisposeMixin";

export default {
  name: "syncConfigDialog",
  mixins: [dialogMixin, resDispose],
  props: {
    dialog: Boolean,
    syncConfigId: Number,
  },
  data() {
    return {
      configForm: {},
      rules: {},
    };
  },
  watch: {
    syncConfigId: {
      handler(newV) {
        if (newV) {
          this.fetchData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    fetchData() {
      agentGetGroupDetailById({ id: this.syncConfigId }).then((res) => {
        this.configForm = { syncTime: res.data.t4 };
      });
    },
    addPost() {
      this.$refs["Dto"].validate((valid) => {
        if (valid) {
          let Dto = { ...this.configForm };
          agentEditSyncConfigGroup({ id: this.syncConfigId, t4: Dto.syncTime })
            .then(() => {
              agentSyncConfigGroup(this.syncConfigId).then((res) => {
                if (res.code === 1) {
                  this.$emit("update:dialog", false);
                  Message({
                    message: "同步成功~",
                    type: "success",
                  });
                } else {
                  Message({
                    message: res.msg,
                    type: "error",
                    duration: 3000,
                  });
                }
              });
            })
            .finally(() => {
              this.loadDialog.close();
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
